import { Box, Divider, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';

export const EventInfo = ({ event }: any) => {
  // Count unique clients
  const uniqueClients = new Set(event.credit_transactions.map((credit: any) => credit.client?.id)).size;

  return (
    <Box sx={{ 
      padding: '8px',
      backgroundColor: 'white',
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      minWidth: '200px'
    }}>
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {format(new Date(event.start), 'dd MMM yyyy')}
      </Typography>
      
      <Stack spacing={1}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Transactions:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }} color={"black"}>
            {event?.credit_transactions?.length}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Clients:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }} color={"black"}>
            {uniqueClients}
          </Typography>
        </Box>

        <Divider sx={{ my: 0.5 }} />

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Total:
          </Typography>
          <Typography variant="body2" sx={{ fontWeight: 600 }} color={"black"}>
            {event.totalAmount.toLocaleString()} TND
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
